import Vue from 'vue'
import VueRouter from 'vue-router'
import { canNavigate } from '@/libs/acl/routeProtection'
import jwt from 'jsonwebtoken'
import { useWindowSize } from '@vueuse/core'
import { getItem } from '@/@core/utils/storage-utils'

const layoutDefine = () => {
  const { width: windowWidth } = useWindowSize()
  const width = Number(windowWidth.value)
  let breakpoint
  const themeBreakpoints = {
    lg: 992,
    md: 768,
    sm: 576,
    xl: 1200,
    xs: 0,
  }
  if (width >= Number(themeBreakpoints.xl)) breakpoint = 'xl'
  else if (width >= Number(themeBreakpoints.lg)) breakpoint = 'lg'
  else if (width >= Number(themeBreakpoints.md)) breakpoint = 'md'
  else if (width >= Number(themeBreakpoints.sm)) breakpoint = 'sm'
  else breakpoint = 'xs'
  return breakpoint === 'xl' || breakpoint === 'lg' || breakpoint === 'md'
    ? 'sidebar'
    : 'topbar'
}

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/home/Home.vue'),
      meta: {
        action: 'read',
        resource: 'Basic',
        layout: layoutDefine(),
      },
    },
    {
      path: '/gutMicrobiomeAnalysis',
      name: 'gut-microbiome-analysis',
      component: () => import('@/views/home/GutMicrobiomeAnalysis.vue'),
      meta: {
        action: 'read',
        resource: 'Basic',
        layout: layoutDefine(),
      },
    },
    {
      path: '/dnaAnalysis',
      name: 'dna-analysis',
      component: () => import('@/views/home/DnaAnalysis.vue'),
      meta: {
        action: 'read',
        resource: 'Basic',
        layout: layoutDefine(),
      },
    },
    {
      path: '/reports',
      name: 'reports',
      component: () => import('@/views/reports/reports.vue'),
      meta: {
        action: 'read',
        resource: 'Basic',
        layout: layoutDefine(),
      },
    },
    // {
    //   path: '/healthScores',
    //   name: 'health-scores',
    //   component: () => import('@/views/reports/healthScores.vue'),
    //   meta: {
    //     action: 'read',
    //     resource: 'Basic',
    //     layout: layoutDefine(),
    //   },
    // },
    // {
    //   path: '/sub-scores/:scoreId',
    //   name: 'sub-scores',
    //   component: () => import('@/views/reports/subScores.vue'),
    //   props: true,
    //   meta: {
    //     action: 'read',
    //     resource: 'Basic',
    //     layout: layoutDefine(),
    //   },
    // },
    // {
    //   path: '/disease-details/:diseaseId',
    //   name: 'disease-details',
    //   component: () => import('@/views/reports/diseaseDetails.vue'),
    //   props: true,
    //   meta: {
    //     action: 'read',
    //     resource: 'Basic',
    //     layout: layoutDefine(),
    //   },
    // },
    // {
    //   path: '/learnMore',
    //   name: 'learn-more',
    //   component: () => import('@/views/reports/learnMore.vue'),
    //   meta: {
    //     action: 'read',
    //     resource: 'Basic',
    //     layout: layoutDefine(),
    //   },
    // },
    // {
    //   path: '/gutPerformance',
    //   name: 'gut-performance',
    //   component: () => import('@/views/reports/gutPerformance.vue'),
    //   meta: {
    //     action: 'read',
    //     resource: 'Basic',
    //     layout: layoutDefine(),
    //   },
    // },
    // {
    //   path: '/uniqueTraits',
    //   name: 'unique-traits',
    //   component: () => import('@/views/reports/uniqueTraits.vue'),
    //   meta: {
    //     action: 'read',
    //     resource: 'Basic',
    //     layout: layoutDefine(),
    //   },
    // },
    // {
    //   path: '/nutritionProfile',
    //   name: 'nutrition-profile',
    //   component: () => import('@/views/reports/nutritionProfile.vue'),
    //   meta: {
    //     action: 'read',
    //     resource: 'Basic',
    //     layout: layoutDefine(),
    //   },
    // },
    // {
    //   path: '/physicalFitness',
    //   name: 'physical-fitness',
    //   component: () => import('@/views/reports/physicalFitness.vue'),
    //   meta: {
    //     action: 'read',
    //     resource: 'Basic',
    //     layout: layoutDefine(),
    //   },
    // },
    {
      path: '/personalFoodList',
      name: 'personal-food-list',
      component: () => import('@/views/recommendations/personalFoodList.vue'),
      meta: {
        action: 'read',
        resource: 'Basic',
        layout: layoutDefine(),
      },
    },
    {
      path: '/personalizedMealPlan',
      name: 'personalized-meal-plan',
      component: () => import('@/views/recommendations/personalizedMealPlan.vue'),
      meta: {
        action: 'read',
        resource: 'Basic',
        layout: layoutDefine(),
      },
    },
    {
      path: '/lifestyleRecommendations',
      name: 'lifestyle-recommendations',
      component: () => import('@/views/recommendations/lifestyleRecommendations.vue'),
      meta: {
        action: 'read',
        resource: 'Basic',
        layout: layoutDefine(),
      },
    },
    {
      path: '/myAccount',
      name: 'my-account',
      component: () => import('@/views/account/Account.vue'),
      meta: {
        action: 'read',
        resource: 'Basic',
        layout: layoutDefine(),
      },
    },
    {
      path: '/welcome',
      name: 'welcome',
      component: () => import('@/views/welcome/Welcome.vue'),
      meta: {
        action: 'read',
        resource: 'Basic',
        layout: 'full',
      },
    },
    {
      path: '/kitRegistration',
      name: 'kit-registration',
      component: () => import('@/views/Kit/Registration.vue'),
      meta: {
        action: 'read',
        resource: 'Basic',
        layout: 'full',
      },
    },
    {
      path: '/questionnaire/:id',
      name: 'questionnaire',
      component: () => import('@/views/questionnaireModule/Questionnaire.vue'),
      meta: {
        action: 'read',
        resource: 'Basic',
        layout: 'full',
      },
    },

    // ============================================================================================================
    // Auth routes
    // ============================================================================================================
    {
      path: '/login',
      name: 'auth-login',
      component: () => import('@/views/auth/Login.vue'),
      meta: {
        layout: 'full',
        action: 'read',
        resource: 'Auth',
      },
    },
    {
      path: '/register',
      name: 'auth-register',
      component: () => import('@/views/auth/Register.vue'),
      meta: {
        layout: 'full',
        action: 'read',
        resource: 'Auth',
      },
    },
    // ============================================================================================================
    // Error routes
    // ============================================================================================================
    {
      path: '/bugReport',
      name: 'bug-report',
      component: () => import('@/views/bug/bugReport.vue'),
      meta: {
        layout: 'full',
        action: 'read',
        resource: 'Basic',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/comingSoon',
      name: 'comingSoon',
      component: () => import('@/views/error/ComingSoon.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/notAuthorized',
      name: 'misc-not-authorized',
      component: () => import('@/views/error/NotAuthorized.vue'),
      meta: {
        layout: 'full',
      },
    },

    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, from, next) => {
  const jwtToken = getItem('jwtToken')
  let isLoggedIn = !!jwtToken
  const decoded = jwt.decode(jwtToken)
  if (decoded === null) {
    isLoggedIn = false
  } else if (Date.now() >= decoded.exp * 1000) {
    localStorage.clear()
    isLoggedIn = false
  }
  if (to.name === 'auth-login') {
    if (isLoggedIn) {
      return next({ name: 'home' })
    }
    return next()
  }
  if (to.name === 'auth-register') return next()
  if (to.name === 'misc-not-authorized') return next()

  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'auth-login' })

    // If logged in => not authorized
    return next({ name: 'misc-not-authorized' })
  }

  // Redirect if logged in
  // ? This sets redirect according to userRole
  // if (to.meta.redirectIfLoggedIn && isLoggedIn) {
  //   const userData = getUserData()
  //   next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
  // }

  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
